// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import CheckboxFilterControlled from '../../../../shared/components/facets/checkbox-filter/controlled';
import DealerHierarchyFacet from '../../../shared/state/dealer-hierarchy-facet';
import DealerHierarchyFacetsAccordion from './dealer-hierarchy-facet-accordion';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import FacetFooter from '../../../../shared/components/facets/facet-footer/index';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import TcsmSettings from '@deere/cps-it.warranty-model-factory/lib/tcsm-settings';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {getIsPinTransferEnabled} from '../../../../product/shared/services/get-is-pin-transfer-enabled-aor';

function handleDealerFacetFilterTextUpdate(filterText) {

    this.actions.updateFacetFilterText(filterText);
    this.actions.updateFilteredTerritories(this.territories, filterText);

}

function handleDealerFacetWipFacetsUpdate(facets) {

    this.actions.updateWipFacets(facets);

}

function handleApprovalLevelFacetItemChange(item, isSelected) {

    const cleanedItem = {
        key: item.key,
        value: item.value
    };

    this.actions.updateSelectedSpaLevelsList(cleanedItem, isSelected);

}

function handleApprovalLevelsFacetItemsToggle() {

    this.actions.toggleSpaLevelsListItems(this.tcsmSettings.allowedSpaLevels);

}

function handleOnReset() {

    this.actions.resetWipFacets(this.territories);
    this.actions.updateFacetFilterText('');
    this.actions.updateFilteredTerritories(this.territories, '');
    this.actions.resetTcsmSettingsFacet(this.selectedSpaLevels);

}

function handleOnApply() {

    if (getIsPinTransferEnabled('add-amount-of-use')) {

        this.actions.readAmountOfUseRequests(this.facets.dealers);

    }
    this.actions.readClosingAccount(this.facets.dealers);
    this.actions.readDuplicatePinPlate(this.facets.dealers);
    this.actions.readMachineStatusUpdates(this.facets.dealers);
    this.actions.readPipCodeRequests(this.facets.dealers);
    this.actions.readSpaClaims(this.facets.dealers, this.tcsmSettings.selectedSpaLevels);
    this.actions.readLaborRateChanges(this.facets.dealers);

}

class FacetsAccordion extends Component {

    state = {
        approvalLevelsExpanded: false,
        dealerLocationExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.approvalLevelsExpanded || this.state.dealerLocationExpanded

    render() {

        return (
            <section className='facets-accordion'>
                <DealerHierarchyFacetsAccordion
                    facetFilterText={this.props.facetFilterText}
                    facets={this.props.facets}
                    filteredTerritories={this.props.filteredTerritories}
                    isExpanded={this.state.dealerLocationExpanded}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    updateFacetFilterText={this.props::handleDealerFacetFilterTextUpdate}
                    updateWipFacets={this.props::handleDealerFacetWipFacetsUpdate}
                />
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.tcsmSettings.selectedSpaLevels, 'key')}
                    isExpanded={this.state.approvalLevelsExpanded}
                    list={addCollectionLabels(this.props.tcsmSettings.allowedSpaLevels, 'value')}
                    minNumberOfItems={1}
                    onChange={this.props::handleApprovalLevelFacetItemChange}
                    onClick={this.onAccordionToggle.bind(this, 'approvalLevelsExpanded')}
                    onToggleAll={this.props::handleApprovalLevelsFacetItemsToggle}
                    title='APPROVAL_LEVELS'
                    valueKey='key'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={this.props.facets.dealers.length === 0}
                        onApply={this.props::handleOnApply}
                        onReset={this.props::handleOnReset}
                    /> : null}
            </section>
        );

    }

}

FacetsAccordion.displayName = 'FacetsAccordion';
FacetsAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    facetFilterText: PropTypes.string.isRequired,
    facets: PropTypes.instanceOf(DealerHierarchyFacet).isRequired,
    filteredTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    selectedSpaLevels: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    tcsmSettings: PropTypes.instanceOf(TcsmSettings).isRequired,
    territories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired
};

export default FacetsAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/facets/facets-accordion.js